@if (serviceaftale?.serviceaftaleState.state == serviceaftaleStateEnum.CreatedPending) {
  <p class="orange">
    Aftalen er ikke startet og opsiges derfor pr. {{ serviceaftale.startDate | date: 'dd.MM.yyyy' }}
  </p>
}

@if (serviceaftale && serviceaftale?.serviceaftaleState.state != serviceaftaleStateEnum.CreatedPending) {
  <div class="form-row">
    <mat-radio-group [(ngModel)]="selectedOpsigType" (change)="opsigPrChange($event)">
      <mat-radio-button [value]="opsigPr.Today">Opsiges nu</mat-radio-button>
      @if (hasEndDate) {
        <mat-radio-button [value]="opsigPr.EndOfInterval">
          Opsiges v slut periode d. {{ periodEndDate | date: 'dd.MM.yyyy' }}
        </mat-radio-button>
      }
      <mat-radio-button [value]="opsigPr.Custom">Opsig pr...</mat-radio-button>
    </mat-radio-group>
  </div>
  @if (selectedOpsigType == opsigPr.Custom) {
    <div class="form-row">
      <form [formGroup]="form">
        <mat-form-field appearance="outline" color="primary">
          <mat-label>Opsig aftalen pr.</mat-label>
          <input #input matInput [matDatepicker]="picker" [min]="$safeNavigationMigration(serviceaftale?.startDate)" formControlName="endDate" />
          <mat-datepicker-toggle matPrefix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
      </form>
    </div>
  }
}
